import { render, staticRenderFns } from "./VoucherTypeInput.vue?vue&type=template&id=4087f1da&scoped=true&"
import script from "./VoucherTypeInput.vue?vue&type=script&lang=js&"
export * from "./VoucherTypeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087f1da",
  null
  
)

export default component.exports